module.exports = __webpack_public_path__ + "img/product.8f7390f5.svg";